export type CatalogCategory = 'kits' | 'holders' | 'inserts' | 'accessories'

export type InsertFamily = 'mg12-roughing' | 'mg12-chipbreaker' | 'dr80'

export interface CatalogItem {
  part: string
  description: string
  category: CatalogCategory
  grade?: string
  radius?: string
  family?: InsertFamily
}

export const categoryMeta: Record<
  CatalogCategory,
  { label: string; href: string }
> = {
  kits: { label: 'Starter Kits', href: '/products/starter-kits/' },
  holders: { label: 'Tool Holders', href: '/products/holders/' },
  inserts: { label: 'Inserts & Chipbreakers', href: '/products/inserts/' },
  accessories: { label: 'Accessories', href: '/products/accessories/' },
}

/** The 13-row Shear Geometry catalog. Descriptions are used verbatim
 *  everywhere the part appears. */
export const catalog: CatalogItem[] = [
  {
    part: 'SG KIT 1"',
    description:
      'Starter kit with 1-inch holder, 10 APGX 331R inserts, Torx driver & extra screws.',
    category: 'kits',
  },
  {
    part: 'SG KIT 3/4"',
    description:
      'Starter kit with 3/4-inch holder, 10 APGX 331R inserts, Torx driver & extra screws.',
    category: 'kits',
  },
  {
    part: 'SALXR 16-3D',
    description: '1-inch shank holder with Torx driver.',
    category: 'holders',
  },
  {
    part: 'SALXR 12-3B',
    description: '3/4-inch shank holder with Torx driver.',
    category: 'holders',
  },
  {
    part: 'APGX 331R',
    description: 'Grade MG12, .016-inch radius insert.',
    category: 'inserts',
    grade: 'MG12',
    radius: '.016 in',
    family: 'mg12-roughing',
  },
  {
    part: 'APGX 332R',
    description: 'Grade MG12, .031-inch radius insert.',
    category: 'inserts',
    grade: 'MG12',
    radius: '.031 in',
    family: 'mg12-roughing',
  },
  {
    part: 'APGX 333R',
    description: 'Grade MG12, .047-inch radius insert.',
    category: 'inserts',
    grade: 'MG12',
    radius: '.047 in',
    family: 'mg12-roughing',
  },
  {
    part: 'APGX 331-30R',
    description: 'Grade MG12, .016-inch radius chipbreaker insert.',
    category: 'inserts',
    grade: 'MG12',
    radius: '.016 in',
    family: 'mg12-chipbreaker',
  },
  {
    part: 'APGX 332-30R',
    description: 'Grade MG12, .031-inch radius chipbreaker insert.',
    category: 'inserts',
    grade: 'MG12',
    radius: '.031 in',
    family: 'mg12-chipbreaker',
  },
  {
    part: 'APGX 331R DR80',
    description: 'Honed .016-inch radius insert with MAX coating.',
    category: 'inserts',
    grade: 'DR80',
    radius: '.016 in',
    family: 'dr80',
  },
  {
    part: 'APGX 332R DR80',
    description: 'Honed .031-inch radius insert with MAX coating.',
    category: 'inserts',
    grade: 'DR80',
    radius: '.031 in',
    family: 'dr80',
  },
  {
    part: 'T-15',
    description: 'Torx driver.',
    category: 'accessories',
  },
  {
    part: '4-15',
    description: 'Insert screw with a low-profile head.',
    category: 'accessories',
  },
]

export const insertFamilies: {
  id: InsertFamily
  title: string
  use: string
}[] = [
  {
    id: 'mg12-roughing',
    title: 'MG12 roughing inserts',
    use: 'For heavier feed rates. The 6061-T6 aluminum roughing guidance names APGX 331R and APGX 332R.',
  },
  {
    id: 'mg12-chipbreaker',
    title: 'MG12 -30R chipbreaker inserts',
    use: 'For lighter feed rates in aluminum, where tighter chip control is the priority.',
  },
  {
    id: 'dr80',
    title: 'DR80 honed, MAX-coated inserts',
    use: 'For titanium, with a more conservative published starting range.',
  },
]
